import { create } from '@theme/create';

export const themed = create(
  new (function () {
    this.buttonPrev = {
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      zIndex: 1,
      left: 3,
      right: 'auto',
      transition: 'opacity 0.2s ease-in-out',
      width: '16px',
      height: '16px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    };

    this.buttonNext = {
      ...this.buttonPrev,
      left: 'auto',
      right: 3,
    };

    this.icon = {
      width: '16px',
      userSelect: 'none',
    };
  })()
);
